module.exports = 'casino@1.6.5'
